import IconButton from '@material-ui/core/IconButton'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import MenuIcon from '@material-ui/icons/Menu'
import React from 'react'
import GridContainer from 'components/Surfaces/GridContainer'
import GridItem from 'components/Surfaces/GridItem'
import { CdnClientUrl } from 'components/Utilities/urlUtils'

const useStyle = makeStyles({
    deltekLogo: {
        height: 20,
        marginTop: 5,
    },
    appLogo: {
        height: 27,
        marginTop: 8,
        marginLeft: 5,
    },
    chevronLogo: {
        marginLeft: 5,
        height: 27,
        marginTop: 3,
    },
    toolBar: {
        maxWidth: '50%',
    },
})

export interface TopBarToolsProps {
    toggleSidebarOpen: (newValue: boolean | 'toggle') => void
    logoOnly?: boolean
    logoWithChildren?: boolean
}

const TopBarTools: React.FC<TopBarToolsProps> = ({
    toggleSidebarOpen,
    logoOnly = false,
    logoWithChildren = false,
    children,
}) => {
    const classes = useStyle()
    const theme = useTheme()
    const smScreen = useMediaQuery(theme.breakpoints.up('sm'))
    return (
        <GridContainer>
            <GridItem
                container
                xs
                sm={8}
                alignItems="center"
                className={classes.toolBar}
            >
                {!logoOnly && (
                    <GridItem>
                        <IconButton
                            color="inherit"
                            onClick={() => toggleSidebarOpen('toggle')}
                            edge="start"
                            data-testid="hamburgerMenu"
                        >
                            <MenuIcon />
                        </IconButton>
                    </GridItem>
                )}
                {smScreen && (
                    <GridItem>
                        <img
                            src={`${CdnClientUrl}/deltek_logo_only_light.svg`}
                            alt="Deltek"
                            className={classes.deltekLogo}
                        />
                    </GridItem>
                )}

                <GridItem>
                    <img
                        src={`${CdnClientUrl}/specpoint_white.svg`}
                        alt="Specpoint"
                        className={classes.appLogo}
                    />
                </GridItem>
                <GridItem>
                    <img
                        src={`${CdnClientUrl}/chevron_white.svg`}
                        alt=">"
                        className={classes.chevronLogo}
                    />
                </GridItem>
            </GridItem>
            {smScreen && !logoOnly && (
                <GridItem container xs alignItems="center">
                    {children}
                </GridItem>
            )}
            {smScreen && logoWithChildren && (
                <GridItem container xs alignItems="center">
                    {children}
                </GridItem>
            )}
        </GridContainer>
    )
}

export default TopBarTools
